<template>
    <div class="carousel-container">
        <image-view v-for="(image, index) of images"
                    :key="index"
                    :class="['carousel-img', status[index]]"
                    size="large"
                    type="background"
                    :url="image"/>
        <div class="carousel-controls">
            <div v-for="(ignored, index) of images"
                 :key="index"
                 :class="{'carousel-button': true,
                          'active': index === current}"
                 @click="setCurrent(index)">
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
	import ImageView from "@/components/ImageView";

	export default {
		name: "TheCarousel",
		components: {ImageView},
		created() {
			this.resetTimer();
			for (let ignored = 0; ignored < this.images.length - 1; ignored++) {
				this.status.push("none");
            }
		},
		props: {
			images: {
				type: Array,
				required: true
			}
		},
		data: () => {
			return {
				status: ["current"],
				current: 0,
				timer: 0,
			}
		},
		methods: {
			setCurrent(x) {
				this.current = x;
				this.resetTimer();
			},
			resetTimer() {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.timer = setInterval((self) => {
					this.current = (self.current + 1) % self.images.length;
				}, 5000, this);
			}
		},
		watch: {
			current(to, from) {
				if (to < from) {
                    this.status[from] = "finish-right";
                    this.status[to] = "prepare-left";
				} else {
					this.status[from] = "finish-left";
					this.status[to] = "prepare-right";
				}
				setImmediate(() => {
					this.$set(this.status, to, "current");
				});
			}
		}
	}
</script>

<style scoped lang="scss">
    .carousel-container {
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
    }

    .carousel-img {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .carousel-controls {
        position: absolute;
        display: flex;
        flex-direction: row;
        width: 100%;
        bottom: 10%;
        justify-content: center;
        z-index: 1;
    }

    .carousel-button {
        height: 4px;
        width: 16px;
        padding: 4px;
        cursor: pointer;
    }

    .carousel-button > div {
        background-color: $p-fg;
        height: 4px;
        width: 16px;
        transition: background-color 0.2s $bezier;
    }

    .carousel-button.active > div {
        background-color: $p-accent;
    }

    .current, .finish-left, .finish-right {
        transition: opacity 0.5s $bezier, transform 0.8s $bezier;
    }

    .finish-right, .prepare-right {
        opacity: 0;
        transform: translate(2em, 0);
    }

    .finish-left, .prepare-left {
        opacity: 0;
        transform: translate(-2em, 0);
    }

    .none {
        opacity: 0;
    }
</style>